import { showToast } from "@emdur/ui";
import { type Proposal, proposalHref } from "../lib/proposals";
export function showProposalDecision(proposal: Proposal) {
  showToast({
    title:
      proposal.state === "rejected"
        ? "Proposal declined"
        : proposal.state === "failed"
          ? "Approved, but the change could not run"
          : proposal.mode === "suggest"
            ? "Suggestion accepted; no change was applied"
            : "Proposal approved",
    action: {
      label: "View decision",
      href: proposalHref(proposal.organization_id, proposal.id),
    },
    tone: proposal.state === "failed" ? "warning" : "positive",
  });
}
